const tabs = [
    { id: 'contact', label: 'Demande d’animation' },
    { id: 'users', label: 'Utilisateurs' },
    { id: 'category', label: 'Categories' },
    { id: 'stat', label: 'Statistiques' },
];

export default tabs;